import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from './Header';
import companyLogo from '../images/B_longtermtec_logo.png';
import siemensLogo from '../images/siemens_logo.svg';
import canadaFlag from '../images/Canada_flag.jpg';
import usaFlag from '../images/US_flag.jpg';
import './ShopSelector.css';

const ShopSelector = () => {
    const navigate = useNavigate();

    return (
        <div className="shop-selector">
            <Header logo={companyLogo} />
            <div className="selector-content">
                <img src={siemensLogo} alt="Siemens" className="siemens-logo" />
                <h1 className="selector-title">Siemens Software Online Store</h1>
                <p className="selector-subtitle">Choose Your Country or Region</p>
                <div className="selector-buttons">
                    <button
                        className="region-card"
                        onClick={() => navigate('/cad')}
                        style={{ backgroundImage: `url(${canadaFlag})` }}
                    >
                        <div className="region-overlay">
                            <span className="region-name">Canada</span>
                            <span className="region-currency">Shop in CAD</span>
                        </div>
                    </button>
                    <button
                        className="region-card"
                        onClick={() => navigate('/usd')}
                        style={{ backgroundImage: `url(${usaFlag})` }}
                    >
                        <div className="region-overlay">
                            <span className="region-name">United States</span>
                            <span className="region-currency">Shop in USD</span>
                        </div>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ShopSelector;
